<template>
  <div class="editor" v-if="editor">
    <editor-menu-bar :editor="editor" v-slot="{ commands, isActive }">
      <div class="menubar">
        <div class="btn-group">
          <button type="button" class="btn btn-sm" title="Bold" :class="{ 'btn-dark': isActive.bold(), 'btn-outline-dark': !isActive.bold() }" @click="commands.bold">
            <svg class="bi" width="18" height="18" fill="currentColor">
              <use :xlink:href="`${bootstrapIcons}#type-bold`"/>
            </svg>
          </button>
          <button type="button" class="btn btn-sm" title="Italic" :class="{ 'btn-dark': isActive.italic(), 'btn-outline-dark': !isActive.italic() }" @click="commands.italic">
            <svg class="bi" width="18" height="18" fill="currentColor">
              <use :xlink:href="`${bootstrapIcons}#type-italic`"/>
            </svg>
          </button>
        </div>

        <div class="btn-group ml-2">
          <button type="button" class="btn btn-sm" title="Bullet list" :class="{ 'btn-dark': isActive.bullet_list(), 'btn-outline-dark': !isActive.bullet_list() }" @click="commands.bullet_list">
            <svg class="bi" width="18" height="18" fill="currentColor">
              <use :xlink:href="`${bootstrapIcons}#list-ul`"/>
            </svg>
          </button>
          <button type="button" class="btn btn-sm" title="Ordered list" :class="{ 'btn-dark': isActive.ordered_list(), 'btn-outline-dark': !isActive.ordered_list() }" @click="commands.ordered_list">
            <svg class="bi" width="18" height="18" fill="currentColor">
              <use :xlink:href="`${bootstrapIcons}#list-ol`"/>
            </svg>
          </button>
        </div>

        <div class="btn-group ml-2">
          <button type="button" class="btn btn-sm" title="Link" :class="{ 'btn-dark': isActive.link(), 'btn-outline-dark': !isActive.link() }" @click="commands.link">
            <svg class="bi" width="18" height="18" fill="currentColor">
              <use :xlink:href="`${bootstrapIcons}#link`"/>
            </svg>
          </button>
        </div>

        <div class="btn-group ml-2">
          <button type="button" class="btn btn-sm btn-outline-dark" @click="commands.undo">
            <svg class="bi" width="18" height="18" fill="currentColor">
              <use :xlink:href="`${bootstrapIcons}#arrow-90deg-left`"/>
            </svg>
          </button>
          <button type="button" class="btn btn-sm btn-outline-dark" @click="commands.redo">
            <svg class="bi" width="18" height="18" fill="currentColor">
              <use :xlink:href="`${bootstrapIcons}#arrow-90deg-right`"/>
            </svg>
          </button>
        </div>
      </div>
    </editor-menu-bar>

    <editor-content class="editor-content mt-2" :editor="editor"></editor-content>
  </div>
</template>

<script>
  import { Editor, EditorContent, EditorMenuBar } from "tiptap"
  import {
    HardBreak,
    BulletList,
    OrderedList,
    ListItem,
    Bold,
    Italic,
    Link,
    History
  } from "tiptap-extensions"

  export default {
    name: "editor",
    components: { EditorContent, EditorMenuBar },
    props: {
      value: {
        type: String
      }
    },
    data() {
      return {
        bootstrapIcons: require("bootstrap-icons/bootstrap-icons.svg"),
        editor: null
      }
    },
    mounted() {
      this.editor = new Editor({
        extensions: [
          new HardBreak(),
          new BulletList(),
          new OrderedList(),
          new ListItem(),
          new Bold(),
          new Italic(),
          new Link(),
          new History()
        ],
        content: this.value,
        onUpdate: ({ getHTML }) => {
          const state = getHTML()
          this.$emit("input", state)
        }
      })
    },
    beforeDestroy() {
      this.editor.destroy()
    }
  }
</script>

<style lang="scss" scoped>
  .editor-content {
    background-clip: padding-box;
    background-color: #fff;
    border-radius: 0.25rem;
    border: 1px solid #ced4da;
    color: #495057;
    display: block;
    font-size: 0.875rem;
    font-weight: 400;
    height: 150px;
    max-height: 400px;
    line-height: 1.5;
    padding: 0.375rem 0.75rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    width: 100%;
    overflow: auto;
  }
</style>